import { createApi } from '@reduxjs/toolkit/query/react';
import { CreateAnswerRequest } from 'domain/question';
import { axiosBaseQuery, getApiBaseUrl } from 'modules/api/utils';

export const answerApi = createApi({
  reducerPath: 'answerApi',
  baseQuery: axiosBaseQuery({ baseURL: getApiBaseUrl('v1') }),
  endpoints: (builder) => ({
    postAnswer: builder.mutation<void, CreateAnswerRequest>({
      query: (data) => ({
        url: `/answer`,
        method: 'POST',
        data,
      }),
    }),
  }),
});
